import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export interface GamenightOption {
  id?: number;
  title: string;
  image_url: string;
  is_active: boolean;
  display_order: number;
}

export interface OptionDialogData {
  option?: GamenightOption;
  isEdit: boolean;
  maxDisplayOrder: number;
}

@Component({
  selector: 'app-option-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatButtonModule,
    MatIconModule
  ],
  templateUrl: './option-dialog.component.html',
  styleUrl: './option-dialog.component.less'
})
export class OptionDialogComponent implements OnInit {
  formData: GamenightOption = {
    title: '',
    image_url: '',
    is_active: true,
    display_order: 0
  };

  constructor(
    public dialogRef: MatDialogRef<OptionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: OptionDialogData
  ) {}

  ngOnInit() {
    if (this.data.isEdit && this.data.option) {
      this.formData = {
        id: this.data.option.id,
        title: this.data.option.title,
        image_url: this.data.option.image_url,
        is_active: this.data.option.is_active,
        display_order: this.data.option.display_order
      };
    } else {
      // For new options, set display order to max + 1
      this.formData.display_order = this.data.maxDisplayOrder + 1;
    }
  }

  onSave() {
    if (!this.formData.title.trim()) {
      return;
    }
    this.dialogRef.close(this.formData);
  }

  onCancel() {
    this.dialogRef.close();
  }
}
